<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Deduction/With Holding (Jenis Potongan Pada AR) 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked"
      >
        <template v-slot:cell(nomor)="data">
          {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
        </template>
          <template v-slot:cell(pajak)="data">
            <span v-if="(data.item.pajak==1)">Yes</span>
          </template>
          <template v-slot:cell(tarif)="data">
            <span v-if="(data.item.pajak==1)">{{data.item.tarif}} %</span>
          </template>
        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-card v-if="showForm">
      <div slot="header">Deduction/With Holding - Add/Edit Form 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
        </div>
      </div>
        <b-row >
          <b-col class="pr-4" cols="6">
              <b-form-group  label-cols=3  label="Deduction Name" >
                  <b-form-input v-model="frmdata.Potongan" :state="!$v.frmdata.Potongan.$error"></b-form-input>
              </b-form-group>
              <b-form-group  label-cols=3  label="With Holding Tax " >
                      <b-form-radio-group class="mt-2" v-model="frmdata.pajak" name="radioPajak">
                        <b-form-radio value="1">Yes (PPh / With Holding Tax)</b-form-radio>
                        <b-form-radio value="0">No (Non Tax)</b-form-radio>
                      </b-form-radio-group>
              </b-form-group>
              <b-form-group v-if="(frmdata.pajak==1)" label-cols=3  label="With Holding Tax Rate" >
                 <b-row>
                   <b-col lg="6">
                      <b-input-group >
                          <b-form-input v-model="frmdata.tarif" type="number"></b-form-input>
                          <b-input-group-append><span class="input-group-text"><strong>%</strong></span></b-input-group-append>
                      </b-input-group>
                   </b-col>
                 </b-row>
              </b-form-group>
              <b-form-group label-cols=3  label="GL Account">
                  <b-input-group >
                      <b-form-input readonly v-model="frmdata.kodeaccInfo" :state="!$v.frmdata.kodeacc.$error"></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="showLkuCoa('kodeacc')" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
              </b-form-group>
          </b-col>
      </b-row>
    </b-card>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true" :lazy="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
  </div>
</template>


<script>
import lkuCoa from "../lookup/lkuCoa";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        Potongan: { required },
        pajak: { required },
        kodeacc: { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList:true,
      showForm:false,
      showFilter:false,
      lkuCoaShow:false,
      lkuCoaCaller:'kodeacc',
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      frmdata:{kodeacc: '',Potongan: '', pajak:0 },
      tblData: {
        tablename:'arpotongan',
        page: 1,
        limit: 20,
        total: 0,
        
        sortBy: null,
        sortDesc: false,
      },
    };
  },
  components: {lkuCoa},
  computed: {
    tblFields(){
      const fields=[
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "Potongan",
            label: "Deduction Name",
            sortable: true
          },
          {
            key: "pajak",
            label: "W/H Tax",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "tarif",
            label: "W/H Tax Rate",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "kodeacc",
            label: "GL Account",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await crud.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.kodeacc= '';
        this.tblData.pajak=  '';
        this.tblData.Potongan=  '';
        this.refresh();
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.kodeaccInfo = data.kodeacc;
      this.frmdata.kodelama = data.IDPotongan;
      let _selected;
      try {
        if (data.kodeacc) {
          _selected = await crud.findcoa({kodeacc: data.kodeacc, tahun: this.tahun});
          if (_selected) this.frmdata.kodeaccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        }
      } catch (error) {
        if (error.message) {
            toastr.error(error.message);
        } else {
            toastr.error(JSON.stringify(error));
        }                      
      }
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              if (this.frmdata.pajak == 0) this.frmdata.tarif = 0 ;
              if (this.frmdata.kodelama) {
                await crud.update({tablename:'arpotongan', key:this.frmdata.kodelama, data:{IDPotongan:this.frmdata.IDPotongan,Potongan:this.frmdata.Potongan, pajak: this.frmdata.pajak, tarif: this.frmdata.tarif, kodeacc: this.frmdata.kodeacc}});
              } else {
                await crud.insert({tablename:'arpotongan', data:{IDPotongan:this.frmdata.IDPotongan,Potongan:this.frmdata.Potongan, pajak: this.frmdata.pajak, tarif: this.frmdata.tarif, kodeacc: this.frmdata.kodeacc}});
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'arpotongan', key:this.model.IDPotongan});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
            this.frmdata[`${this.lkuCoaCaller}Info`] = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.frmdata[this.lkuCoaCaller] = _selected.kodeacc;
        this.lkuCoaShow=false;
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
